
import HeroSection from "@/components/home/HeroSection";
import HallOfFameSection from "@/components/home/HallOfFameSection";
import SponsorsSection from "@/components/home/SponsorsSection";
import AwesomeMembersSection from "@/components/home/AwesomeMembersSection";
import TechPromSection from "@/components/home/TechPromSection";
import HangoutHighlightsSection from "@/components/home/HangoutHighlightsSection";
import GalleryHighlightSection from "@/components/home/GalleryHighlightSection";
import JoinUsSection from "@/components/JoinUsSection";
import { useEffect, useState } from "react";
import { BsArrowUp } from "react-icons/bs";
import Layout from "../components/layouts/Layout";



export default function Home() {

  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowTopBtn(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <Layout>
        <main>
          <div id="hero">
            <HeroSection />
          </div>

          <HallOfFameSection />

          <div id="sponsors">
            <SponsorsSection />
          </div>

          <AwesomeMembersSection />

          <TechPromSection />

          <div id="tech-hangout">
            <HangoutHighlightsSection />
          </div>

          <GalleryHighlightSection />

          <JoinUsSection />
        </main>

        {showTopBtn && (
          <button
            onClick={() => scrollTo("hero")}
            className="fixed z-50 bottom-6 right-6 p-3 bg-primary text-white rounded-full shadow-lg"
          >
            <BsArrowUp className="h-5 w-5" />
          </button>
        )}
      </Layout>
    </div>
  );
}
